import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import { Hero } from '../../../shared/components/hero';
import { Theme } from '../../../modules/headerBar/themes';
import { Page } from '../../../shared/components/page';
import messages from './kioskHome.messages';
import { MarketExperiences } from './kioskHome.styles';

export class KioskHome extends PureComponent {
  static propTypes = {
    kioskData: PropTypes.object,
    intl: PropTypes.object.isRequired,
    logKioskViewedExperiences: PropTypes.func.isRequired,
    experiences: PropTypes.arrayOf(PropTypes.object),
  };

  componentDidMount() {
    this.props.logKioskViewedExperiences(this.props.experiences);
  }

  render() {
    const { kioskData = {}, intl, experiences } = this.props;
    const { heroTitle, heroDescription, heroMedia, videoPoster, logo } = kioskData;

    return (
      <Page headerTheme={Theme.LIGHT}>
        <Helmet title={heroTitle} />

        <Hero
          small
          title={heroTitle}
          description={heroDescription}
          media={heroMedia}
          videoPoster={videoPoster}
          kioskLogo={logo}
        />

        <MarketExperiences
          experiences={experiences}
          title={intl.formatMessage(messages.counter, { count: experiences.length })}
        />
      </Page>
    );
  }
}
